import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]
const _hoisted_2 = { class: "mt-x6 flex justify-center" }
const _hoisted_3 = { class: "c-magic-line c-magic-line--underline text-dusty-grey" }

import useGiftPackaging, { GiftPackagingViewMode } from '@/shared/checkout/gift-packaging/useGiftPackaging';
import useStoreContextBasket from '@/storecontext/basket/useBasket';
import useB2CBasket from '@/b2c/basket/useBasket';
import authStore from '@/shared/auth/auth.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'GiftPackagingConfirm',
  setup(__props) {

const { labels, setViewMode, clearActiveItemId, activeItemId } = useGiftPackaging();
const { removeGiftPackingFromItem: removeGiftPackingFromItemStoreContext } = useStoreContextBasket();
const { removeGiftPackingFromItem: removeGiftPackingFromItemB2C } = useB2CBasket();

const goToEditMode = (): void => {
    setViewMode(GiftPackagingViewMode.Details);
};

const removeFromBasket = (): void => {
    if (activeItemId.value) {
        if (authStore.isSignedInAsStore) {
            removeGiftPackingFromItemStoreContext(activeItemId.value);
        } else {
            removeGiftPackingFromItemB2C(activeItemId.value);
        }
    }
    clearActiveItemId();
};


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", {
      innerHTML: _unref(labels).editPackagingDialogHeader
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: "mr-x4",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (removeFromBasket()), ["prevent"]))
      }, [
        _createElementVNode("span", _hoisted_3, _toDisplayString(_unref(labels).removeButtonText), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        class: "c-button c-button--primary min-w-100",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (goToEditMode()), ["prevent"]))
      }, _toDisplayString(_unref(labels).editButtonText), 1)
    ])
  ]))
}
}

})